/**
 * Pragmatic email check: allows Gmail-style plus-addressing and common local-part chars.
 * Firebase / mail providers accept these; avoids false negatives from \w-only patterns.
 */
export function isValidEmailAddress(value) {
  if (value == null || typeof value !== 'string') return false
  const v = value.trim()
  if (!v) return false
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9][a-zA-Z0-9.-]*\.[a-zA-Z]{2,}$/.test(v)
}
